import { Tag, Typography } from 'antd'
import { useEffect, useState } from 'react'
import React from 'react'
import { useParams } from 'react-router-dom'

import { UserService } from '@services/UserService'

import type { FeatureFlagRule, UserPermissions } from '../../../../../types'

export const AdditionalInfoTab = () => {
    const [permissions, setPermissions] = useState<UserPermissions>()
    const [featureFlagRules, setFeatureFlagRules] = useState<FeatureFlagRule[]>([])
    const { userId } = useParams()

    const fetch = async () => {
        try {
            const permissions = await UserService.getPermissions(userId!)
            const featureFlagRules = await UserService.getFeatureFlagRules(userId!)
            setPermissions(permissions)
            setFeatureFlagRules(featureFlagRules)
        } catch (err) {
            console.error('Error retrieving user information', err)
        }
    }

    useEffect(() => {
        if (userId) {
            fetch()
        }
    }, [userId])

    return (
        <>
            <Typography.Title level={2}>Feature Flags</Typography.Title>
            {featureFlagRules?.map(featureFlagRule => (
                <React.Fragment key={featureFlagRule.featureFlag?.key}>
                    {featureFlagRule.featureFlag && (
                        <Tag key={featureFlagRule.featureFlag?.key}>{featureFlagRule.featureFlag?.key}</Tag>
                    )}
                </React.Fragment>
            ))}
            <Typography.Title level={2}>Feature Flag Rules</Typography.Title>
            <pre>{JSON.stringify(featureFlagRules, null, 2)}</pre>
            <Typography.Title level={2}>Permissions</Typography.Title>
            <pre>{JSON.stringify(permissions, null, 2)}</pre>
        </>
    )
}
